"use client";

import useGetCCPAFooter from "rivals/services/getCCPAFooter/useGetCCPAFooter";
import { WrapperProps } from "./types";
import TweetBlock from ".";

const TweetBlockContainer = (props: WrapperProps): React.JSX.Element => {
  const { data } = useGetCCPAFooter();

  return (
    <TweetBlock hasEmbedConsent={!!data?.thirdPartyEmbedConsent} {...props} />
  );
};

export default TweetBlockContainer;
